/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
}
:host .option,
:host .option-parent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host .option-parent {
  padding: 0px;
  border-left: 0px;
  background-color: transparent;
}
:host .option-parent-item {
  font-weight: 700;
  padding: 0 calc(16rem/14) 0 calc(10rem/14);
  border-left: 6px solid transparent;
}
:host .option-parent-item:hover,
:host .option-parent-item.selected,
:host .option-parent.selected > .option-parent-item {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
  border-color: var(--davinci-color-primary,#007CC1);
}
:host .option-parent .option {
  padding-left: calc(32rem/14);
}
:host .option,
:host .option > span,
:host .option-parent-item > .label,
:host > .container > div.currentvalue > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
:host davinci-checkbox {
  margin: auto 0px;
  padding-left: calc(8rem /14);
}`;
export { style };
